var _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZeichen1PxClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.999 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    stroke: "currentColor",
    x1: 0.4946,
    y1: 29.5,
    x2: 29.3433,
    y2: 0.4323
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    stroke: "currentColor",
    x1: 29.2517,
    y1: 29.5,
    x2: 0.403,
    y2: 0.4323
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeichen1PxClose);
export default __webpack_public_path__ + "static/media/Zeichen-1px_close.2e5007ed15f4fa1c227b60ad5842c56c.svg";
export { ForwardRef as ReactComponent };